import { convertToUTCTime } from 'utils/time';
export const activityTypeEnums = {
  startShift: 'START_SHIFT',
  endShift: 'END_SHIFT',
  startBreak: 'START_BREAK',
  endBreak: 'END_BREAK',
  available: 'AVAILABLE',
  unavailable: 'UNAVAILABLE',
  startTask: 'START_TASK',
  endTask: 'END_TASK',
  enterSite: 'ENTER_SITE',
  exitSite: 'EXIT_SITE',
  onBreak: 'ON_BREAK',
  onTask: 'ON_TASK',
};
export const convertActivityTypeToUserStatus = activityType => {
  switch (activityType) {
    case activityTypeEnums.startShift:
    case activityTypeEnums.endBreak:
    case activityTypeEnums.endTask:
      return activityTypeEnums.available;
    case activityTypeEnums.endShift:
      return activityTypeEnums.unavailable;
    case activityTypeEnums.startTask:
      return activityTypeEnums.onTask;
    case activityTypeEnums.startBreak:
      return activityTypeEnums.onBreak;
    default:
      return 'UNKNOWN_ACTIVITY_TYPE';
  }
};

export const translateActivityType = type => {
  switch (type) {
    /**
     * TODO: the enum should be the key in the translation file
     */
    case activityTypeEnums.startShift:
      return 'Clock On';
    case activityTypeEnums.startBreak:
      return 'Start Break';
    case activityTypeEnums.endBreak:
      return 'Finish Break';
    case activityTypeEnums.endShift:
      return 'Clock Off';
    case activityTypeEnums.enterSite:
      return 'Enter Site';
    case activityTypeEnums.exitSite:
      return 'Leave Site';
    case activityTypeEnums.startTask:
      return 'Start Task';
    case activityTypeEnums.endTask:
      return 'Stop Task';
    default:
      return 'UNKNOWN_TYPE';
  }
};

export const fetchLastActivityTime = (activityDetails, reorderedActivities) => {
  if (!activityDetails.activityId) {
    return reorderedActivities[0].activityTime;
  }

  const currentActivity = activity =>
    activity.id === activityDetails.activityId;

  const currentActivityIndex = reorderedActivities.findIndex(currentActivity);
  if (reorderedActivities.length > 1) {
    const object = Object.values(reorderedActivities)[currentActivityIndex + 1];
    return object?.activityTime;
  }
  return '';
};

export const fetchNextActivityTime = (activityDetails, reorderedActivities) => {
  if (!activityDetails.activityId) {
    return '';
  }
  const currentActivity = activity =>
    activity.id === activityDetails.activityId;

  const currentActivityIndex = reorderedActivities.findIndex(currentActivity);
  if (reorderedActivities.length > 1) {
    const object = Object.values(reorderedActivities)[currentActivityIndex - 1];
    return object?.activityTime;
  }
  return '';
};

export const maxDateRestrictor = (activityType, nextActivityTime) => {
  if (activityType && activityType.id !== activityTypeEnums.endShift) {
    return nextActivityTime;
  }
  return undefined;
};

export const minDateRestrictor = (activityType, lastActivityTime) => {
  if (!activityType || activityType.id !== activityTypeEnums.startShift) {
    return lastActivityTime;
  }
  return undefined;
};

export const reorderAccordingRecentActivity = activities => {
  const reorderedActivities = [...activities].sort(
    (a, b) => new Date(b.activityTime) - new Date(a.activityTime),
  );
  const avilableActivities = [];
  reorderedActivities.forEach(item => {
    if (!item.deleted) {
      avilableActivities.push(item);
    }
  });
  return avilableActivities;
};

export const transformNewShiftActivityObject = ({
  currentShiftDetails,
  newShiftInfo,
  localTimezone,
}) => {
  const shift = {
    id: currentShiftDetails.id,
    startTime: currentShiftDetails.startTime,
    createdByID: newShiftInfo.reporterId,
    userId: currentShiftDetails.userId,
    activities: [
      {
        activityType: newShiftInfo.activityType,
        activityTime: convertToUTCTime({
          date: newShiftInfo.activityTime,
          timezone: localTimezone,
        }),
        id: newShiftInfo.id,
      },
    ],
  };
  return shift;
};

export const transformUpdateShiftActivityObject = ({
  newShiftActivityUUID,
  newShiftActivityObject,
  localTimezone,
}) => {
  const editedShiftActivityObject = {
    id: newShiftActivityUUID,
    activityType: newShiftActivityObject.activityType.id,
    activityTime: convertToUTCTime({
      date: newShiftActivityObject.activityTime,
      timezone: localTimezone,
    }),
  };
  return editedShiftActivityObject;
};

export const deleteMatchingActivity = (
  activityDetails,
  reorderedActivities,
) => {
  const currentActivity = activity =>
    activity.id === activityDetails.shiftInfo.id;

  const currentActivityIndex = reorderedActivities.findIndex(currentActivity);
  if (activityDetails.shiftInfo.activityType === activityTypeEnums.startBreak) {
    if (reorderedActivities.length > 1 && currentActivityIndex !== 0) {
      const object = Object.values(reorderedActivities)[
        currentActivityIndex - 1
      ];
      return object?.activityType === activityTypeEnums.endBreak
        ? object
        : undefined;
    }
  }
  return null;
};
